module.exports = __webpack_public_path__ + "static/media/па.f2d6608b.mp3";